import { Mail, Phone, MessageCircle, Briefcase } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { EnquiryForm } from "./EnquiryForm";
import { useSite } from "../context/SiteContext";
import { img } from "../lib/images";

const Item = ({ icon: Icon, label, value, href, testid }) => (
  <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" data-testid={testid} className="group flex items-center gap-4 rounded-2xl border border-sand/15 p-4 transition-colors hover:bg-sand/10">
    <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-sand text-ink"><Icon className="h-4 w-4" /></span>
    <span>
      <span className="block text-xs uppercase tracking-[0.18em] text-sand/70">{label}</span>
      <span className="block text-sand">{value}</span>
    </span>
  </a>
);

export const Contact = () => {
  const site = useSite();
  const c = site.contact;
  return (
  <section id="contact" data-testid="contact-section" className="relative overflow-hidden bg-ink py-24 text-sand sm:py-32">
    <img {...img("room")} loading="lazy" decoding="async" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-15" />
    <div className="relative mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Reveal>
          <Eyebrow light>Let's Work Together</Eyebrow>
          <h2 className="font-display text-4xl leading-[1.08] sm:text-5xl">{c.title}</h2>
          <p className="mt-6 text-base leading-relaxed text-sand/80 sm:text-lg">
            {c.text}
          </p>
        </Reveal>
        <Reveal delay={0.1} className="mt-10 space-y-3">
          <Item icon={MessageCircle} label="WhatsApp" value="Chat with our team" href={site.whatsappUrl} testid="contact-whatsapp-link" />
          <Item icon={Mail} label="Email" value={c.email} href={`mailto:${c.email}`} testid="contact-email-link" />
          <Item icon={Phone} label="Phone" value={c.phone} href={site.phoneHref} testid="contact-phone-link" />
          <Item icon={Briefcase} label="Careers" value="View open positions" href="#careers" testid="contact-careers-link" />
        </Reveal>
      </div>
      <Reveal delay={0.15} className="lg:col-span-7">
        <EnquiryForm />
      </Reveal>
    </div>
  </section>
  );
};
